/**
 * BFCache-friendly page lifecycle helpers.
 * Avoids unload handlers; restores UI state on pageshow (persisted).
 */
(function () {
  'use strict';

  function onPageShow(event) {
    document.documentElement.classList.toggle('tb-bfcache-restored', !!event.persisted);
    if (!event.persisted) return;

    // Re-enable lazy images that browsers may leave mid-load after restore.
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.complete) return;
      var src = img.currentSrc || img.src;
      if (src) {
        img.loading = 'eager';
      }
    });

    document.dispatchEvent(new CustomEvent('tb:bfcache:restore', { detail: { persisted: true } }));
  }

  function onPageHide(event) {
    document.dispatchEvent(
      new CustomEvent('tb:bfcache:hide', { detail: { persisted: !!event.persisted } })
    );
  }

  window.addEventListener('pageshow', onPageShow);
  window.addEventListener('pagehide', onPageHide);
})();
